import { render, staticRenderFns } from "./InfoTrustSection.vue?vue&type=template&id=24b382bb&"
import script from "./InfoTrustSection.vue?vue&type=script&lang=ts&"
export * from "./InfoTrustSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports